import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';
import './About.css';
import { UserContext } from '../../context/UserContext';

const About_es = () => {
  const { user } = useContext(UserContext);
  const lang = useLanguage();

  return (
    <>
      <title>Sobre SeegSoog | Inversión Inmobiliaria Inteligente Fuera de Mercado</title>
      <div className="about-container">
        <div className="about-content">
          <h1>Sobre SeegSoog.com</h1>
          <p>
            SeegSoog.com es un mercado creado para tomar decisiones de inversión inmobiliaria más inteligentes y rápidas en el espacio fuera de mercado de EE. UU. Reúne a vendedores motivados e inversores serios, estandariza las cifras que importan y
            agrega análisis impulsados por IA para que cada acuerdo pueda evaluarse en igualdad de condiciones.
          </p>

          <h2>Por qué existe</h2>
          <p>
            SeegSoog comenzó a partir de una simple frustración: llegar a los vendedores correctos era lento, comparar acuerdos con parámetros consistentes era complicado y analizar propuestas tomaba demasiado tiempo. Esta plataforma fue creada para
            solucionar eso centralizando el contacto, alineando métricas y automatizando el análisis pesado para que el enfoque permanezca en el rendimiento y el riesgo.
          </p>

          <h2>Qué ofrece</h2>
          <ul>
            <li>Listados centralizados de vendedores motivados con comunicación directa y segura.</li>
            <li>Métricas financieras estandarizadas para una comparación equitativa entre mercados y tipos de propiedad.</li>
            <li>Informes bajo demanda asistidos por IA que revelan métricas clave, tendencias, sensibilidades y señales de alerta.</li>
          </ul>

          <h2>Nuestro enfoque</h2>
          <p>
            La transparencia, la integridad y la velocidad guían cada función, desde entradas y metodologías claras hasta flujos de trabajo de mensajería y decisiones optimizados. El objetivo es simple: ayudar a los inversores a actuar con confianza
            mientras se les da a los vendedores un camino profesional hacia compradores serios.
          </p>

          <p>
            <Link to={`/${lang}/map`}>Explore las oportunidades actuales</Link>, aprenda cómo funcionan las herramientas o <Link to={`/${lang}/contact-us`}>póngase en contacto</Link> para compartir comentarios y dar forma a lo que vendrá.
          </p>
          {user.isLoggedIn && user.isAdmin && <p className="admin-message">Ha iniciado sesión como administrador.</p>}
        </div>
      </div>
    </>
  );
};

export default About_es;
